<template>
  <v-multiselect
    :options='roles'
    label="nom"
    track-by="code"
    :value="realValue"
    :searchable="false"
    :allow-empty="false"
    :disabled="disabled"
    placeholder="Sélectionner un rôle"
    deselect-label=""
    select-label=""
    selectedLabel=""
    @select="setRole"
  >
    <template slot='noResult'>
      Aucune rôle correspondante
    </template>
  </v-multiselect>
</template>

<script>
export default {
  name: 'SelectRole',

  props: {
    value: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      roles: [
        { code: 'admin', nom: 'Administrateur' },
        { code: 'tech', nom: 'Technicien' },
        { code: 'exploit', nom: 'Exploitant' }
      ]
    }
  },

  computed: {
    realValue () {
      return this.roles.find(o => o.code === this.value)
    }
  },

  methods: {
    setRole (role) {
      this.$emit('input', role.code)
    }
  }

}
</script>
